import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CodeSnippetComponent } from "../../common/code-snippet/code-snippet.component";

@Component({
  selector: "app-test-case-detail-modal",
  standalone: true,
  imports: [CommonModule, CodeSnippetComponent],
  templateUrl: "./test-case-detail-modal.component.html",
  styleUrl: "./test-case-detail-modal.component.scss",
})
export class TestCaseDetailModalComponent implements OnInit {
  @Input() configs: any = {};

  activeModal = inject(NgbActiveModal);
  isActive: boolean = false;
  sections: any = [];

  expandedRows = new Set<number>([0]);

  ngOnInit(): void {
    this.getFormattedData();
  }

  getFormattedData() {
    this.sections = [
      {
        title: "User Story",
        fields: [
          { label: "User Story ID", value: this.configs?.data?.userStoryId },
          {
            label: "User Story",
            value: this.configs?.data?.userStoryDescription,
          },
          {
            label: "Acceptance Criteria",
            value: this.configs?.data?.acceptanceCriteria,
          },
        ],
      },
      {
        title: "Test Case",
        fields: [
          { label: "Test Case ID", value: this.configs?.data?.testCaseId || this.configs?.data?.testCaseID },
          { label: "Test Case", value: this.configs?.data?.testScenario },
          { label: "Prerequisites", value: this.configs?.data?.preCondition },
          { label: "Test Steps", value: this.configs?.data?.steps },
          {
            label: "Expected Results",
            value: this.configs?.data?.expectedResults,
          },
        ],
      },
      {
        title: "Code Snippet",
        fields: [
          {
            label: "Source Code Path",
            value: this.configs?.data?.sourceCodePath,
          },
          { label: "Method Name", value: this.configs?.data?.methodName },
          { label: "Code Snippets", value: this.configs?.data?.codeSnippets },
        ],
      },
    ];
  }

  toggleSection(index: number): void {
    if (this.expandedRows.has(index)) {
      this.expandedRows.delete(index);
    } else {
      this.expandedRows.add(index);
    }
  }

  isExpanded(index: number): boolean {
    return this.expandedRows.has(index);
  }

  getAcceptanceCriteriaList(value: string): string[] {
    return value
      .split(".")
      .filter((item) => item.trim().length > 0)
      .map((item) => item.trim());
  }

  getListItems(value: string): string[] {
    return value.split("\n").filter((item) => item.trim().length > 0);
  }

  hasNumbering(value: string): boolean {
    if (!value) return false;
    const items = value.split("\n").filter((item) => item.trim().length > 0);
    if (items.length === 0) return false;
    // Check if first item starts with a number followed by period or closing parenthesis
    const firstItem = items[0].trim();
    return /^\d+[.)]/.test(firstItem);
  }

  getCleanListItems(value: string): string[] {
    return value
      .split("\n")
      .filter((item) => item.trim().length > 0)
      .map((item) => {
        const trimmed = item.trim();
        // Remove leading number with period or parenthesis if present
        return trimmed.replace(/^\d+[.)]\s*/, '');
      });
  }

  close(): void {
    this.activeModal.close();
  }
}
